jQuery( document ).ready(function($) {
    const namespace = 'ct_accordion';
    const subnamespace = 'ct_accordionitem';

    $("." + namespace + " ." + subnamespace + " [data-toggle='collapse']").click(function() {
        var accordionContainer = $(this).closest("." + namespace);
        var isHidden = $(this).hasClass('collapsed');

        // close all if unique only
        if (accordionContainer.hasClass('unique')) {
            accordionContainer.find("[data-toggle='collapse']").addClass('collapsed');
            accordionContainer.find('.collapse').collapse('hide');
        }

        // toggle collapsed state for clicked element
        if (isHidden) {
            $(this).removeClass('collapsed');
        }
        else {
            $(this).addClass('collapsed');
        }
        $(this).closest("." + subnamespace).find('.collapse').collapse('toggle');
    });
});